__turbopack_context__.v({
  "contact-information-form": "WLwUaq_contact-information-form",
  "contact-information-form__content": "WLwUaq_contact-information-form__content",
  "contact-information-form__content--reduce-spacing": "WLwUaq_contact-information-form__content--reduce-spacing",
  "contact-information-form__fieldset": "WLwUaq_contact-information-form__fieldset",
  "contact-information-form__footer": "WLwUaq_contact-information-form__footer",
  "contact-information-form__heading": "WLwUaq_contact-information-form__heading",
  "contact-information-form__legend": "WLwUaq_contact-information-form__legend",
  "contact-information-form__separator": "WLwUaq_contact-information-form__separator",
  "contact-information-form__sub-heading": "WLwUaq_contact-information-form__sub-heading",
});
